import { alpha, styled } from '@mui/material/styles';
import { DataGridPro } from '@mui/x-data-grid-pro';

export const DataTableRoot = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  padding: 0,
  width: '100%',
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.divider}`,
  overflow: 'hidden',
}));

export const DataTableGrid = styled(DataGridPro)(({ theme }) => ({
  border: 'none',
  borderRadius: 0,
  width: '100%',
  backgroundColor: theme.palette.common.white,
  '--DataGrid-rowBorderColor': theme.palette.divider,
  '& .MuiDataGrid-columnHeaders': {
    minHeight: '48px !important',
    maxHeight: 'none !important',
    backgroundColor: 'transparent',
    borderBottom: 'none',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: theme.spacing(1, 1),
    backgroundColor: alpha(theme.palette.primary.main, 0.04),
    height: 'unset !important',
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    whiteSpace: 'normal',
    alignItems: 'center',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    ...theme.typography['label-small'],
    color: theme.palette.text.primary,
    whiteSpace: 'normal',
    overflow: 'visible',
    textOverflow: 'unset',
    overflowWrap: 'break-word',
  },
  '& .MuiDataGrid-row': {
    minHeight: '32px !important',
    maxHeight: '32px !important',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '& .MuiDataGrid-cell': {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(0, 0, 0, 1),
    ...theme.typography['body-small'],
    backgroundColor: theme.palette.grey[50],
    color: theme.palette.text.disabled,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'left',
    overflow: 'hidden',
  },
  '& .data-table-cell-ellipsis': {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    minWidth: 0,
  },
  '& .MuiDataGrid-cell.data-table-editable-cell': {
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
  },
  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-row:hover .MuiDataGrid-cell': {
    backgroundColor: theme.palette.grey[50],
  },
  '& .MuiDataGrid-row:hover .MuiDataGrid-cell.data-table-editable-cell': {
    backgroundColor: 'transparent',
  },
  '& .data-table-total-row': {
    backgroundColor: theme.palette.table.summaryBackground,
  },
  '& .data-table-total-row .MuiDataGrid-cell': {
    backgroundColor: theme.palette.table.summaryBackground,
    color: theme.palette.text.primary,
    ...theme.typography['label-small'],
    lineHeight: 1.57,
    borderBottom: 'none',
  },
  '& .MuiDataGrid-pinnedRows': {
    backgroundColor: theme.palette.table.summaryBackground,
    boxShadow: 'none',
  },
  '& .MuiDataGrid-pinnedRows .MuiDataGrid-row': {
    backgroundColor: theme.palette.table.summaryBackground,
  },
  '& .MuiDataGrid-footerContainer': {
    display: 'none',
  },
  '& .MuiDataGrid-virtualScroller': {
    minHeight: 'unset',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
})) as typeof DataGridPro;
